import { toSafeString } from '@shared/utils';

const sortRoleOptions = (roleItems = []) => {
  return [...roleItems].sort((left, right) => {
    const leftName = toSafeString(left?.name).toLowerCase();
    const rightName = toSafeString(right?.name).toLowerCase();

    if (leftName === rightName) {
      return toSafeString(left?.id).localeCompare(toSafeString(right?.id));
    }

    return leftName.localeCompare(rightName);
  });
};

export default sortRoleOptions;
